// A token in Status.VALID may still be a 2FA-pending stub: the sign-in
// reducer stores a 2fa_required response as a SUCCESS (is2faRequired: true,
// no access token). Route gating must not treat that stub as an
// authenticated session — doing so bounces App through the authed tree,
// a Bearer-less /me call, a 401, and a SIGN_OUT before landing back on
// the login form.
export function isFullyAuthenticated(token) {
  return token.isValid() && !(token.data && token.data.is2faRequired);
}
